import { render } from "./IconChevronDown.vue?vue&type=template&id=06ee8e45"
const script = {}

import "./IconChevronDown.vue?vue&type=style&index=0&id=06ee8e45&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__